export const PERMISSION_OVERRIDE_TYPES = {
  GRANT: 'Grant',
  DENY: 'Deny'
};

export const PERMISSION_OVERRIDE_TYPE_LABELS = {
  [PERMISSION_OVERRIDE_TYPES.GRANT]: 'Grant',
  [PERMISSION_OVERRIDE_TYPES.DENY]: 'Deny'
};
